export function newify(self, type) {
    return self instanceof type ? self : Object.create(type.prototype);
}
